const DUIMP_STATUS = {
  EM_ABERTO: 'EM_ABERTO',
  FINALIZADO: 'FINALIZADO',
  SEM_SOLUCAO: 'SEM_SOLUCAO',
};

const DUIMP_STATUS_LABELS = {
  [DUIMP_STATUS.EM_ABERTO]: 'Em Aberto',
  [DUIMP_STATUS.FINALIZADO]: 'Finalizado',
  [DUIMP_STATUS.SEM_SOLUCAO]: 'Sem Solução',
};

const DUIMP_APPROVAL_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

const DUIMP_APPROVED_BY_TYPE = {
  BANK: 'bank',
  AUTO: 'auto',
};

const OPERATION = {
  DUIMP_DUE: {
    MAX_PROTOCOLS: 12
  },
  INVOICE: {
    MAX_ITEMS: 15
  }
};

// Export CommonJS (Backend)
if (typeof module !== 'undefined' && module.exports)
  module.exports = { OPERATION, DUIMP_STATUS, DUIMP_STATUS_LABELS, DUIMP_APPROVAL_STATUS, DUIMP_APPROVED_BY_TYPE };

// Export ESM (Frontend)
export { OPERATION, DUIMP_STATUS, DUIMP_STATUS_LABELS, DUIMP_APPROVAL_STATUS, DUIMP_APPROVED_BY_TYPE };
